module.exports = __webpack_public_path__ + "img/1514624395.b4dda821.jpg";